import { Col, Form, Row } from 'antd';
import { FormInstance } from 'antd/lib/form/hooks/useForm';
import React, { useEffect, useState } from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';
import InputComponent from 'components/atoms/InputComponent';
import TableComponent from 'components/atoms/TableComponent';
import Title from 'components/atoms/Title';
import TranslateText from 'components/hoc/TranslateText';
import FormWrapper from 'components/molecules/FormWrapper';

import { IFSluzbyPutData } from 'services/statniSprava/FSluzbaPut';
// eslint-disable-next-line object-curly-newline
import { IIsinTable, IIsinTableParams, isinTableDataApi } from 'services/statniSprava/isinTable';

interface IIsinTableComponent {
    upperForm: FormInstance;
    setShowIsinTable: React.Dispatch<React.SetStateAction<boolean>>;
    formIsinName: string;
}

const IsinTable: React.FC<IIsinTableComponent> = ({ upperForm, setShowIsinTable, formIsinName }) => {
    const sluzba = window.location.hash.split('/')[4] as keyof IFSluzbyPutData;
    const [form] = Form.useForm();
    const [tableParams, setTableParams] = useState<IIsinTableParams>({
        limit: 10,
        offset: 0,
        order: 'cval:desc',
        sluzba: sluzba
    });
    const [tableData, setTableData] = useState<IIsinTable>();
    const [tableLoading, setTableLoading] = useState<boolean>();

    useEffect(() => {
        setTableData(undefined);
        tableParams && setTableLoading(true);
        tableParams &&
            isinTableDataApi(tableParams)
                .then(data => setTableData(data))
                .finally(() => setTableLoading(false));
    }, [tableParams]);

    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    const onFinish = (values: any) =>
        setTableParams({
            offset: tableParams.offset,
            limit: 10,
            order: tableParams.order,
            sluzba: sluzba,
            ...(values.isin && {
                isin: values.isin
            }),
            ...(values.isinnazev && {
                isinnazev: values.isinnazev
            }),
            ...(values.emic && {
                emic: values.emic
            }),
            ...(values.emicnazev && {
                emicnazev: values.emicnazev
            })
        });

    const columns = [
        {
            title: <TranslateText>ISIN</TranslateText>,
            dataIndex: 'isin',
            key: 'isin'
        },
        {
            title: <TranslateText>NAZEV_CELY</TranslateText>,
            dataIndex: 'isinnazev',
            key: 'isinnazev'
        },

        {
            title: <TranslateText>IC_EMITENTA</TranslateText>,
            dataIndex: 'emic',
            key: 'emic'
        },
        {
            title: <TranslateText>NAZEV_EMITENTA</TranslateText>,
            dataIndex: 'emicnazev',
            key: 'emicnazev'
        }
    ];

    return (
        <>
            <Title level={5} text={'EMISE_FILTER'} />
            <FormWrapper onFinish={onFinish} outForm={form}>
                <Row gutter={8}>
                    <Col span={5}>
                        <InputComponent label="ISIN" name="isin" maxLength={100} notRequired={true} capitalize={true} />
                    </Col>
                    <Col span={6}>
                        <InputComponent label="EMISE_NAZEV_CELY" name="isinnazev" maxLength={100} notRequired={true} />
                    </Col>
                    <Col span={5}>
                        <InputComponent
                            label="SEZNAM_ISINU_ID_EMITENTA"
                            name="emic"
                            maxLength={100}
                            notRequired={true}
                        />
                    </Col>
                    <Col span={6}>
                        <InputComponent label="NAZEV_EMITENTA" name="emicnazev" maxLength={100} notRequired={true} />
                    </Col>
                </Row>
                <Row>
                    <ButtonComponent
                        buttontext={'FILTROVAT'}
                        onClick={() => form.submit()}
                        style={{
                            marginRight: 10
                        }}
                        id="isinTableFiltrovat"
                    />
                    <ButtonComponent
                        buttontext={'VYMAZAT_FILTR'}
                        onClick={() => {
                            form.resetFields();
                            setTableParams({
                                limit: 10,
                                offset: 0,
                                order: 'cval:desc',
                                sluzba: sluzba
                            });
                        }}
                        htmlType="button"
                        id="isinTableClearFiltr"
                    />
                </Row>
            </FormWrapper>
            <Title level={5} text={'VYBRANE_EMISE'} />
            <TableComponent
                onRow={record => {
                    return {
                        onClick: () => {
                            upperForm.setFieldsValue({
                                [formIsinName]: record.isin
                            });
                            window.scrollTo(0, 0);
                            setShowIsinTable(false);
                        }
                    };
                }}
                rowKey={(e, i) => e.isin || i || 0}
                columns={columns}
                dataSource={tableData?.emise}
                loading={tableLoading}
                locale={{
                    emptyText: <TranslateText>ZADNE_UDAJE</TranslateText>
                }}
                pagination={{
                    total: tableData?.count,
                    onChange: page =>
                        setTableParams(pv => {
                            return {
                                ...pv,
                                offset: (page - 1) * 10
                            };
                        }),
                    current: (tableParams?.offset ? tableParams.offset : 0) / 10 + 1,
                    showSizeChanger: false
                }}
            />
            <Row className="button-row">
                <ButtonComponent
                    id="isinTableZpetBtn"
                    buttontext="ZPET"
                    type="default"
                    onClick={() => {
                        window.scrollTo(0, 0);
                        setShowIsinTable(false);
                    }}
                />
            </Row>
        </>
    );
};

export default IsinTable;
